<template>
  <div class="page">
    <div class="not-found">
      404: Page not found.
    </div>
  </div>
</template>

<script>
export default {
	name: "PageNotFound",
	data() {
		return {}
	},
	mounted() {

	},
	methods: {}
}
</script>
<style lang="scss" scoped>
@use "../../scss/_variables.scss";
.page {
	height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}
.not-found{
	text-align: center;
	font-family: variables.$font-primary;
	font-size: 2vw;

  @media screen and (max-width: 650px) {
    font-size: 4vw;
  }
}
</style>